import Cookies from "js-cookie";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { DateRangePicker } from "./_components/date-range-picker/date-range-picker2";
import { useDateRangeStore } from "./_components/date-range-picker/use-date-range-store";
import { fetchAllLeaveApplicationsForSuperAdminQueryOptions } from "@/config/queries/superadmin-query-options";
import { convertUTCtoIST } from "@/utils";
import { Spinner } from "@/components/ui/spinner/spinner";
import { DataTable } from "./_components/leave-application-table/data-table";
import { columns } from "./_components/leave-application-table/columns";

const EmployeesLeavesActivity = () => {
  const saKey = Cookies.get("key") as string;
  const { date } = useDateRangeStore();

  const startdate = date as Date;
  const enddate = date as Date;

  const { data, isPending, isFetching } = useQuery(
    fetchAllLeaveApplicationsForSuperAdminQueryOptions(saKey, {
      startdate: convertUTCtoIST(new Date(startdate.setHours(0))),
      enddate: convertUTCtoIST(new Date(enddate.setHours(23))),
    })
  );

  const leaveApplicationData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.LeaveApplication === undefined) {
      return [];
    }

    const result = data?.LeaveApplication?.map((la) => {
      return {
        id: la?._id,
        leaveType: la?.leaveType,
        reason: la?.reason,
        startDate: la?.startDate,
        endDate: la?.endDate,
        status: la?.status,
        employeeName: la?.employee?.name,
        employeeEmail: la?.employee?.email,
        createdAt: la?.createdAt,
        attachment: la?.attachment,
        isPaid: la?.isPaid,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [isPending, isFetching, data]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Leave Applications</h3>

        <div className="flex items-center gap-3">
          <DateRangePicker />
        </div>
      </div>

      {isPending ? (
        <div className="h-20 mt-10 flex items-center justify-center">
          <Spinner size="small">
            <p>Searching for Leave Applications...</p>
          </Spinner>
        </div>
      ) : data?.LeaveApplication?.length ? (
        <div className="mt-5">
          <DataTable data={leaveApplicationData} columns={columns} />
        </div>
      ) : (
        <div className="border h-20 flex items-center justify-center mt-5">
          No Leave Applications
        </div>
      )}
    </div>
  );
};

export default EmployeesLeavesActivity;
